
import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Nl2brPipe } from '../pipes/nl2br.pipe';
import { DIALOG_DATA, DialogOptions } from './dialogs';
/**
 * ConfirmOptions
 */
export interface ConfirmOptions extends DialogOptions {
  okText: string;
  cancelText: string;
}
/**
 * Component
 */
@Component({
  selector: 'dialog-confirm',
  standalone: true,
  imports: [Nl2brPipe],
  template: `
    @if (data.title) {
      <header class="modal-header">
        <h4 class="modal-title">{{data.title}}</h4>
      </header>
    }
    
    <div class="modal-body" [innerHTML]="data.message | nl2br"></div>
    
    <footer class="modal-footer">
      <div class="d-flex  w-100 gap-3">
        <button type="reset" class="btn btn-secondary w-100" ngbAutofocus (click)="modal.close(false)">{{data.cancelText}}</button>
        <button type="submit" class="btn btn-primary w-100" ngbAutofocus (click)="modal.close(true)" autofocus>{{data.okText}}</button>
      </div>
    </footer>
    `,
})
export class ConfirmComponent {
  public modal  = inject(NgbActiveModal);
  public data   = inject<ConfirmOptions>(DIALOG_DATA);
}
